import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48aec654"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = { class: "list-content" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick", "onContextmenu"]
const _hoisted_6 = {
  key: 0,
  style: {"width":"100%","height":"100%"}
}
const _hoisted_7 = ["title"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "note-time" }
const _hoisted_11 = {
  key: 1,
  style: {"width":"100%","height":"100%"}
}
const _hoisted_12 = { class: "new-note-title" }
const _hoisted_13 = { class: "note-time" }
const _hoisted_14 = {
  key: 1,
  class: "no-data"
}
const _hoisted_15 = { class: "content" }
const _hoisted_16 = { class: "toolbar" }
const _hoisted_17 = ["title"]
const _hoisted_18 = ["title"]
const _hoisted_19 = { class: "search-box" }
const _hoisted_20 = {
  key: 0,
  class: "search-results"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "code" }
const _hoisted_23 = ["title"]
const _hoisted_24 = { class: "market" }
const _hoisted_25 = { class: "quote-icon" }
const _hoisted_26 = ["title"]
const _hoisted_27 = { class: "date-box" }
const _hoisted_28 = { class: "custom-header" }
const _hoisted_29 = { class: "header-nav" }
const _hoisted_30 = { class: "header-title" }
const _hoisted_31 = { class: "header-nav" }
const _hoisted_32 = { class: "date-footer" }
const _hoisted_33 = { class: "date-picker-trigger" }
const _hoisted_34 = {
  key: 0,
  class: "date-text"
}
const _hoisted_35 = { class: "editor-area" }
const _hoisted_36 = ["placeholder"]
const _hoisted_37 = { class: "editwrap" }
const _hoisted_38 = { class: "footer-operation" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_PlusOutlined = _resolveComponent("PlusOutlined")!
  const _component_BoldOutlined = _resolveComponent("BoldOutlined")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_DoubleLeftOutlined = _resolveComponent("DoubleLeftOutlined")!
  const _component_LeftOutlined = _resolveComponent("LeftOutlined")!
  const _component_RightOutlined = _resolveComponent("RightOutlined")!
  const _component_DoubleRightOutlined = _resolveComponent("DoubleRightOutlined")!
  const _component_a_calendar = _resolveComponent("a-calendar")!
  const _component_CalendarOutlined = _resolveComponent("CalendarOutlined")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_Divedit = _resolveComponent("Divedit")!
  const _component_optionalshares = _resolveComponent("optionalshares")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["stocknotes", [_ctx.theme, { 'page-loaded': _ctx.pageLoaded }]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["tab-item", { active: _ctx.radiovalue === 4 }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleTabChange(4)))
        }, _toDisplayString(_ctx.tran('个股相关')), 3),
        _createElementVNode("div", {
          class: _normalizeClass(["tab-item", { active: _ctx.radiovalue === 1 }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleTabChange(1)))
        }, _toDisplayString(_ctx.tran('全部笔记')), 3)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_spin, { spinning: _ctx.loading }, {
          default: _withCtx(() => [
            _createVNode(_Transition, {
              name: "note-list",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_ctx.noteslist.length && !_ctx.loading)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.noteslist, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: item.ID,
                          class: _normalizeClass({ 'active': _ctx.currentNote.ID === item.ID, 'emptynote': !item.ID }),
                          onClick: ($event: any) => (_ctx.getCurrentNote(item)),
                          onContextmenu: _withModifiers(($event: any) => (_ctx.onRightClick(item, $event)), ["prevent"])
                        }, [
                          _createVNode(_component_a_dropdown, { trigger: ['contextmenu'] }, {
                            overlay: _withCtx(() => [
                              _createVNode(_component_a_menu, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_menu_item, {
                                    onClick: ($event: any) => (_ctx.deleteNoteById(item)),
                                    style: {"color":"red"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.tran('删除')), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            default: _withCtx(() => [
                              (item.ID)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createElementVNode("div", {
                                      class: "note-title",
                                      title: item.Title || _ctx.stripHtml(item.Content)
                                    }, [
                                      (item.Title)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.Title), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.stripHtml(item.Content)), 1))
                                    ], 8, _hoisted_7),
                                    _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.moment(item.PubTime * 1000).format('YYYY-MM-DD HH:mm')), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.emptynotetitle), 1),
                                    _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.moment(item.PubTime * 1000).format('YYYY-MM-DD HH:mm')), 1)
                                  ]))
                            ]),
                            _: 2
                          }, 1024)
                        ], 42, _hoisted_5))
                      }), 128))
                    ]))
                  : (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createTextVNode(_toDisplayString(_ctx.tran('暂无内容，点击')), 1),
                        _createVNode(_component_a_button, {
                          type: "link",
                          onClick: _ctx.addEmptyNote
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.tran('新建笔记')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["spinning"])
      ]),
      _createElementVNode("div", {
        class: "new-note-btn",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addEmptyNote && _ctx.addEmptyNote(...args)))
      }, [
        _createVNode(_component_PlusOutlined, { class: "icon" }),
        _createElementVNode("span", null, _toDisplayString(_ctx.tran('新建笔记')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_a_space, { size: 15 }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: "tool-btn",
              onMousedown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.execBold && _ctx.execBold(...args))),
              title: _ctx.tran('加粗')
            }, [
              _createVNode(_component_BoldOutlined)
            ], 40, _hoisted_17),
            _createElementVNode("span", {
              class: "tool-btn",
              onMousedown: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"])),
              title: _ctx.tran('引用')
            }, [
              _createVNode(_component_a_popover, {
                visible: _ctx.showSelect,
                "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showSelect) = $event)),
                trigger: "click",
                placement: "bottomLeft",
                overlayClassName: "stock-search-popover"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_a_input_search, {
                      value: _ctx.searchText,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchText) = $event)),
                      placeholder: _ctx.tran('名称和代码搜索'),
                      onSearch: _ctx.handleSearch,
                      onInput: _cache[6] || (_cache[6] = e => _ctx.handleSearch(e.target.value)),
                      allowClear: true
                    }, null, 8, ["value", "placeholder", "onSearch"]),
                    (_ctx.options.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.Id,
                              class: "search-item",
                              onClick: ($event: any) => (_ctx.handleChange(item))
                            }, [
                              _createElementVNode("span", _hoisted_22, _toDisplayString(item.Code), 1),
                              _createElementVNode("span", {
                                class: "name",
                                title: item.Name
                              }, _toDisplayString(item.Name), 9, _hoisted_23),
                              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.getMarketName(item.MarketCode)), 1)
                            ], 8, _hoisted_21))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.tran('添加股票')), 1)
                ]),
                _: 1
              }, 8, ["visible"])
            ], 40, _hoisted_18),
            _createElementVNode("span", {
              class: "tool-btn date-tool-btn",
              onMousedown: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["prevent"])),
              title: _ctx.tran('K线日期')
            }, [
              _createVNode(_component_a_popover, {
                visible: _ctx.showDateSelect,
                "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showDateSelect) = $event)),
                trigger: "click",
                placement: "topLeft",
                overlayClassName: "date-search-popover",
                getPopupContainer: _ctx.getCalendarContainer
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_a_calendar, {
                      fullscreen: false,
                      value: _ctx.selectedDate,
                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedDate) = $event)),
                      onSelect: _ctx.onDateSelect,
                      disabledDate: _ctx.handleDateDisabled
                    }, {
                      headerRender: _withCtx(({ value, onChange }) => [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createVNode(_component_DoubleLeftOutlined, {
                              onClick: ($event: any) => (onChange(value.clone().subtract(1, 'year'))),
                              class: "nav-icon"
                            }, null, 8, ["onClick"]),
                            _createVNode(_component_LeftOutlined, {
                              onClick: ($event: any) => (onChange(value.clone().subtract(1, 'month'))),
                              class: "nav-icon"
                            }, null, 8, ["onClick"])
                          ]),
                          _createElementVNode("div", _hoisted_30, _toDisplayString(value.format('YYYY年M月')), 1),
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(_component_RightOutlined, {
                              onClick: ($event: any) => (onChange(value.clone().add(1, 'month'))),
                              class: "nav-icon"
                            }, null, 8, ["onClick"]),
                            _createVNode(_component_DoubleRightOutlined, {
                              onClick: ($event: any) => (onChange(value.clone().add(1, 'year'))),
                              class: "nav-icon"
                            }, null, 8, ["onClick"])
                          ])
                        ])
                      ]),
                      dateFullCellRender: _withCtx(({ current }) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["custom-date-cell", {
                        'selected': _ctx.selectedDate && current.isSame(_ctx.selectedDate, 'day'),
                        'disabled': _ctx.handleDateDisabled(current),
                        'other-month': !current.isSame(_ctx.selectedDate || _ctx.moment(), 'month')
                      }])
                        }, _toDisplayString(current.date()), 3)
                      ]),
                      _: 1
                    }, 8, ["value", "onSelect", "disabledDate"]),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.tran('今日')) + "：" + _toDisplayString(_ctx.moment().format('YYYY年M月D日')), 1)
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_33, [
                    _createVNode(_component_CalendarOutlined, { class: "calendar-icon" }),
                    (_ctx.selectedDate)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.selectedDate.format('YYYY-MM-DD')), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["visible", "getPopupContainer"])
            ], 40, _hoisted_26)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_35, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "title-input",
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.currentNote.Title) = $event)),
          placeholder: _ctx.tran('请输入标题'),
          onInput: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.markEdited && _ctx.markEdited(...args))),
          maxlength: "60"
        }, null, 40, _hoisted_36), [
          [_vModelText, _ctx.currentNote.Title]
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createVNode(_component_Divedit, {
            theme: _ctx.theme,
            value: _ctx.content,
            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.content) = $event)),
            onInput: _ctx.changecontent,
            onMouseout: _ctx.getGb,
            ref: "diveditRef",
            disableHuShenStock: _ctx.isFangDeZhiTou
          }, null, 8, ["theme", "value", "onInput", "onMouseout", "disableHuShenStock"])
        ])
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.submitNote
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.tran('保存笔记')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      (_ctx.noteslist.length === 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "editor-mask",
            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.addEmptyNote && _ctx.addEmptyNote(...args)))
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.tran('新建笔记')), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_optionalshares)
  ], 2))
}